import { Component, OnInit } from '@angular/core';
import { CommandService } from '../../services/command.service';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { AsyncPipe, NgStyle } from "@angular/common";

@Component({
    selector: 'gbc-command-spinner',
    templateUrl: './command-spinner.component.html',
    styleUrls: ['./command-spinner.component.scss'],
    imports: [LoadingSpinnerComponent, AsyncPipe, NgStyle]
})
export class CommandSpinnerComponent {
  constructor(public commandService: CommandService) {}
}
